import React from 'react';
import Product from '../../Types/Product';
import { translate } from '../../Services/translation';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';

interface ChoosenWallpaperInterface {
  activeProduct?: Product;
  setProductSelectorOpen: (open: boolean) => void;
}

const ChoosenWallpaper = ({
  activeProduct,
  setProductSelectorOpen,
}: ChoosenWallpaperInterface) => {
  const handleChooseWallpaperClick = () => {
    let productContainerElem = document.getElementById(
      'product-selector-container'
    );
    setProductSelectorOpen(true);
    if (productContainerElem) {
      productContainerElem.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <>
      {activeProduct ? (
        <div className="flex flex-1 items-center gap-2">
          {activeProduct.images && activeProduct.images.length > 0 && (
            <ResponsiveImage
              {...activeProduct.images[0]?.imageModel}
              imgProps={{
                className:
                  'h-10 w-full rounded object-cover transition duration-500 group-hover:scale-105 aspect-[3/4] store-screen:hidden',
              }}
            />
          )}
          <div className="flex flex-col">
            <a href={activeProduct.url}>
              <h6>{activeProduct.name}</h6>
            </a>
            <span className="text-sm text-gray-500">
              {translate('general.product')}: {activeProduct.id}
            </span>
          </div>
        </div>
      ) : (
        <div className="flex flex-1 items-center gap-2">
          <div className="h-10 rounded border border-dashed border-gray-500 bg-gray-100 aspect-[3/4]  store-screen:hidden"></div>
          <div className="flex flex-col">
            <h6>{translate('simulator.no-choosen-wallpaper')}</h6>
            <span
              onClick={() => handleChooseWallpaperClick()}
              className="cursor-pointer text-sm text-gray-500 underline"
            >
              {translate('simulator.choose-wallpaper')}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default ChoosenWallpaper;
